import React from "react";
import {renderInto} from "../common/reactRoot";
import './styles.css';
import {_t} from "../js/translation";
import _ from "lodash";
import Select, {components} from "react-select";
import getDefaultTimezone from "../app/common/tools/getDefaultTimezone";

const MultiValue = (props) => {
    const { index, getValue } = props;
    const allSelected = getValue();
    const isLastVisible = index === 1;
    const isHidden = index > 1;

    if (isHidden) return null;

    return (
        <>
            {isLastVisible && allSelected.length > 2 && (
                <span className="extra-items">
                    +{allSelected.length - 2} more
                </span>
            )}
            <components.MultiValue {...props} />
        </>
    );
};

const CustomOption = (props) => {
    const { data, isSelected, innerRef, innerProps } = props;
    return (
        <div ref={innerRef} {...innerProps} className="react-select__option react-select__option-custom">
            <div className="form-group form-group__checkbox">
                <input type="checkbox" checked={isSelected} readOnly/>
                <label className={"label"}>
                    <span className={"custom-checkbox"}></span>
                    <span className={"label--txt"}>{data.label}</span>
                </label>
            </div>


        </div>
    );
};

class RegistrationController {

    constructor() {
        this.isOAuth = window.IS_OAUTH === true;

        this.fields = {
            email: '#fos_user_registration_form_email',
            password: '#fos_user_registration_form_plainPassword',
            slug: '#fos_user_registration_form_slug',
            fullName: '#fos_user_registration_form_fullName',
            timezone: '#fos_user_registration_form_timezone',
            gRecaptchaResponse: '#fos_user_registration_form_gRecaptchaResponse',
            termsAndConditions: '#fos_user_registration_form_termsAndConditions',
        }
        this.errors = {
            slug: [],
            fullName: [],
            email: [],
            password: [],
            userCategories: [],
            gRecaptchaResponse: [],
            termsAndConditions: [],
        };
        this.run();
    }

    run() {
        $.ajaxSetup({
            headers: {
                'X-CSRF-TOKEN': window.X_CSRF_TOKEN
            }
        });
        if (!this.isOAuth) {
            this.initStep1();
        }
        this.initStep2();
        this.initGetTimezone();
        this.initHandleValidate();
        this.initCategorySelectField();
    }

    // Step 1: email + password + terms → Continue button
    initStep1() {
        let _this = this;
        let emailValidating = false;

        _this.initStrongPasswordPopup();
        _this.togglePasswordVisibility('fos_user_registration_form_plainPassword');

        $(this.fields.email).on('blur', function () {
            if (emailValidating) return;
            emailValidating = true;
            _this.validateEmail(function () {
                emailValidating = false;
                _this.showErrors();
            });
        });

        $('#registration_step_1_continue').on('click', function () {
            const passwordValid = _this.validatePassword();
            const termsValid = _this.validateTermsAndConditions();

            _this.validateEmail(function (emailValid) {
                emailValidating = false;

                if (!passwordValid || !termsValid || !emailValid) {
                    _this.showErrors();
                    return;
                }

                $('.registration-step.step-1').hide();
                $('.registration-step.step-2').show().addClass('active');
                $('.registration-step-info.step-1').removeClass('active').addClass('complete');
                $('.registration-step-info.step-2').addClass('active');

                window.dispatchEvent(new Event('resize'));
            });
        });
    }

    // Step 2: slug + fullName + categories + captcha (non-oauth) + terms (oauth) → Submit
    initStep2() {
        let _this = this;
        let form = $('#user_registration_form');

        $('#registration_step_2_back').on('click', function () {
            $('.registration-step.step-2').hide().removeClass('active');
            $('.registration-step.step-1').show().addClass('active');
            $('.registration-step-info.step-2').removeClass('active');
            $('.registration-step-info.step-1').removeClass('complete').addClass('active');
        });

        $(_this.fields.slug).bind('keypress', function (event) {
            let regexp = /^[a-z0-9\-]*$/;
            return regexp.test(event.key);
        });

        $(_this.fields.fullName).on('input', function () {
            _this.validateFullName();
            _this.showErrors();
        });

        form.on('submit', function (e) {
            e.preventDefault();
            let isValid = true;

            if (!_this.validateFullName()) {
                isValid = false;
            }

            if (!_this.validateUserCategories()) {
                isValid = false;
            }

            if (_this.isOAuth) {
                if (!_this.validateTermsAndConditions()) {
                    isValid = false;
                }
            } else {
                let captcha = $(_this.fields.gRecaptchaResponse).val();
                if (!captcha) {
                    _this.errors.gRecaptchaResponse = [_t('errors.registration.captcha')];
                    isValid = false;
                } else {
                    _this.errors.gRecaptchaResponse = [];
                }
            }

            if (!isValid) {
                _this.showErrors();
                return;
            }

            _this.validateSlug(function (slugValid) {
                if (!slugValid) {
                    _this.showErrors();
                    return;
                }
                form[0].submit();
            });
        });

    }

    showErrors() {
        let _this = this;
        _.forEach(_this.errors, function (errors, key) {
            let container = $('#registration_form_container_' + key);
            container.removeClass('has-danger');
            container.find('.form-control-label--danger').remove();
            if (errors.length) {
                container.addClass('has-danger');
                _.forEach(errors, function (error) {
                    container.append('<div class="form-control-label form-control-label--danger">' + error + '</div>')
                });
            }
        });
    }

    initGetTimezone() {
        $(this.fields.timezone).val(getDefaultTimezone());
    }

    initCategorySelectField() {
        let _this = this;
        let domContainer = document.querySelector('.category-select-field');
        if (domContainer) {
            const field = $(domContainer);
            let options = field.data('options');
            let defaultValue = [];
            let valueFromData = field.data('value');

            if (valueFromData) {
                _.forOwn(valueFromData, function (value, key) {
                    if (value && key) {
                        defaultValue.push({
                            value: value,
                            label: _t(value)
                        })
                    }
                });
            }

            _.forOwn(options, function (category, key) {
                options[key].label = _t(category.label);
            });

            _this.hideOrHowOtherCategoryField(defaultValue, false);

            renderInto(
                domContainer,
                <Select
                    closeMenuOnSelect={false}
                    hideSelectedOptions={false}
                    components={{
                        MultiValue,
                        Option: CustomOption
                    }}
                    defaultValue={defaultValue}
                    options={options}
                    name={field.data('name')}
                    id={field.data('id')}
                    placeholder={_t('Select relevant business categories')}
                    isMulti={true}
                    classNamePrefix={"react-select"}
                    className={field.data('class')}
                    onChange={_this.hideOrHowOtherCategoryField.bind(_this)}
                />
            );
        }
    }

    hideOrHowOtherCategoryField(values, isOnChange = true) {
        if (isOnChange) {
            if (values.length) {
                this.errors.userCategories = [];
            } else {
                this.errors.userCategories = [_t('errors.registration.userCategories_required')];
            }
            this.showErrors();
        }

        let hideOtherCategory = true;
        _.forOwn(values, function (value) {
            if (value.value === 'other') {
                hideOtherCategory = false;
                return false;
            }
        });

        let otherCategoryField = $('#other_category_field');

        if (hideOtherCategory) {
            otherCategoryField.find('input').val('');
            otherCategoryField.hide();
        } else {
            otherCategoryField.show();
        }
    }

    validateSlug(callback) {
        let _this = this;
        let slugField = $(this.fields.slug);
        if (slugField.length) {
            let slug = slugField.val();

            if (slug.length) {
                let regexp = /^[a-z0-9\-]*$/;
                if (regexp.test(slug)) {
                    $.get('/api/registration/validate-user-slug/' + slug).then((response) => {
                        if (response.is_valid) {
                            _this.errors.slug = [];
                        } else {
                            _this.errors.slug = [_t('errors.registration.slug')]
                        }

                        callback(response.is_valid);
                    });
                } else {
                    _this.errors.slug = [_t('Your slug can contain only lowercase and "a-z", "0-9", "-" chars.')]
                    callback(false);
                }
            } else {
                _this.errors.slug = [_t('errors.registration.slug_required')]
                callback(false);
            }
        } else {
            callback(true);
        }
    }

    validateEmail(callback) {
        let _this = this;
        let emailField = $(this.fields.email);

        if (!emailField.length) {
            callback(true);
            return;
        }

        let email = emailField.val();

        $.post('/api/registration/validate-user-email', {email: email}).then((response) => {
            if (response.is_valid) {
                _this.errors.email = [];
            } else {
                _this.errors.email = [_t('errors.registration.email')]
            }

            callback(response.is_valid);
        });
    }

    validatePassword() {
        let field = $(this.fields.password);
        let password = field.val();
        let minLength = parseInt(field.attr('minlength')) || 6;

        if (!password) {
            this.errors.password = [_t('errors.registration.password_required')];
            return false;
        }
        if (password.length < minLength) {
            this.errors.password = [_t('errors.registration.password_min_length').replace('%min%', minLength)];
            return false;
        }
        this.errors.password = [];
        return true;
    }

    validateFullName() {
        let isValid = true;
        let fullNameField = $(this.fields.fullName);

        if (!fullNameField.val().length) {
            isValid = false;
            this.errors.fullName = [_t('errors.registration.fullName')];
        } else {
            this.errors.fullName = [];
        }

        return isValid;
    }

    validateTermsAndConditions() {
        if (!$(this.fields.termsAndConditions).is(':checked')) {
            this.errors.termsAndConditions = [_t('errors.registration.termsAndConditions')];
            return false;
        }
        this.errors.termsAndConditions = [];
        return true;
    }

    validateUserCategories() {
        let _this = this;
        let isValid = true;
        let categoryField = $("input[name='fos_user_registration_form[userCategories][]']");

        if (!categoryField.length) {
            isValid = false;
            _this.errors.userCategories = [_t('errors.registration.userCategories_required')];
        }

        if (categoryField.length === 1) {
            categoryField.map(function () {
                if (!$(this).val()) {
                    isValid = false;
                    _this.errors.userCategories = [_t('errors.registration.userCategories_required')];
                }
            })
        }

        if (isValid) {
            _this.errors.userCategories = [];
        }

        return isValid;
    }

    initHandleValidate() {
        let _this = this;

        $(_this.fields.slug).on('blur', function () {
            _this.validateSlug(_this.showErrors.bind(_this));
        });
    }

    initStrongPasswordPopup () {
        var _this = this;
        let passwordPowerPopup = jQuery(".password-power");
        let password = jQuery("#fos_user_registration_form_plainPassword");
        let passwordStrength = jQuery("#password-strength");
        let lowUpperCase = jQuery(".low-upper-case i");
        let number =jQuery(".one-number i");
        let specialChar = jQuery(".one-special-char i");
        //let eightChar = jQuery(".eight-character i");
        let txt = jQuery(".password-power--text-type");
        let txtWeak = jQuery(".password-power--text-type-weak");
        let txtNormal = jQuery(".password-power--text-type-normal");
        let txtStrong = jQuery(".password-power--text-type-strong");
        let txtVeryStrong = jQuery(".password-power--text-type-very-strong");

        password.on("keyup", function(){
            let passVal = password.val();
            checkStrength(passVal);
            passwordPowerPopup.addClass('--is-in');
        });
        password.on('blur', function (){
            setTimeout(function (){
                passwordPowerPopup.removeClass('--is-in');
            }, 200)
        })
        password.on('focus', function (){
            let pass = jQuery("#fos_user_registration_form_plainPassword").val();
            if( pass.length != 0 ){
                passwordPowerPopup.toggleClass('--is-in');
            }
        })

        function checkStrength(password) {
            let strength = 0;

            //If password contains both lower and uppercase characters
            if (password.match(/([a-z].*[A-Z])|([A-Z].*[a-z])/)) {
                strength += 1;
                lowUpperCase.removeClass('fa-circle');
                lowUpperCase.addClass('fa-check');
            } else {
                lowUpperCase.addClass('fa-circle');
                lowUpperCase.removeClass('fa-check');
            }
            //If it has numbers and characters
            if (password.match(/([0-9])/)) {
                strength += 1;
                number.removeClass('fa-circle');
                number.addClass('fa-check');
            } else {
                number.addClass('fa-circle');
                number.removeClass('fa-check');
            }
            //If it has one special character
            if (password.match(/([!,%,&,@,#,$,^,*,?,_,~])/)) {
                strength += 1;
                specialChar.removeClass('fa-circle');
                specialChar.addClass('fa-check');
            } else {
                specialChar.addClass('fa-circle');
                specialChar.removeClass('fa-check');
            }
            //If password is greater than 7
            if (password.length >= 5) {
                strength += 1;
                // eightChar.removeClass('fa-circle');
                // eightChar.addClass('fa-check');

                if (password.length >= 10) {
                    strength += 1;
                }
            } else {
                // eightChar.addClass('fa-circle');
                // eightChar.removeClass('fa-check');
            }

            // If value is less than 2
            if (strength == 0 ) {
                passwordStrength.removeClass('progress-bar-warning');
                passwordStrength.removeClass('progress-bar-danger');
                passwordStrength.removeClass('progress-bar-success');
                passwordStrength.css("width", '0%');
                txt.hide();
                txtWeak.show()
            } else if (strength == 1 || password.length < 1 ) { //5
                passwordStrength.removeClass('progress-bar-warning');
                passwordStrength.removeClass('progress-bar-success');
                passwordStrength.addClass('progress-bar-danger');
                passwordStrength.css("width", '20%');
                txt.hide();
                txtWeak.show()
            } else if (strength == 2 || password.length < 3 ) { //7
                passwordStrength.removeClass('progress-bar-success');
                passwordStrength.removeClass('progress-bar-danger');
                passwordStrength.addClass('progress-bar-warning');
                passwordStrength.css("width", '40%');
                txt.hide();
                txtNormal.show()
            } else if (strength == 3 || password.length < 5) {
                passwordStrength.addClass('progress-bar-success');
                passwordStrength.removeClass('progress-bar-danger');
                passwordStrength.removeClass('progress-bar-warning');
                passwordStrength.css("width", '70%');
                txt.hide();
                txtStrong.show()
            } else if (strength >= 4) {
                passwordStrength.removeClass('progress-bar-warning');
                passwordStrength.removeClass('progress-bar-danger');
                passwordStrength.addClass('progress-bar-success');
                passwordStrength.css("width", '100%');
                txt.hide();
                txtVeryStrong.show()
            }
        }
    }

    togglePasswordVisibility(passwordFieldId) {
        const passwordField = document.getElementById(passwordFieldId);
        const toggleButton = document.querySelector('.show-pass');

        if (!passwordField || !toggleButton) {
            console.error('Elements not found');
            return;
        }

        let isVisible = false;
        const icon = toggleButton.querySelector('i');

        function updateState() {
            isVisible = !isVisible;
            passwordField.type = isVisible ? 'text' : 'password';
            toggleButton.classList.toggle('--is-visible', isVisible);
            icon.classList.toggle('fa-eye', isVisible);
            icon.classList.toggle('fa-eye-slash', !isVisible);
        }

        toggleButton.addEventListener('click', updateState);
    }
}

new RegistrationController();
